import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { isMobile } from '@zorba-shared/client/Services/clientService';
import {
  getOffers,
  setCurrentPage,
  setPageSize,
} from '../../../../reducers/Offer/actions';
import { getColumns } from './constants';

import './index.scss';

const tableScroll = {
  scrollToFirstRowOnChange: true,
  x: isMobile() ? true : 'max-content',
};

export default ({ scrollToTheButtonsContainer }) => {
  const [mounted, setMounted] = useState(false);
  const dispatch = useDispatch();
  const {
    isFetchingOffers,
    offers,
    currentPage,
    pageSize,
    total,
    appliedFilters,
  } = useSelector(({ OfferReducer }) => OfferReducer);
  const { organization, userDetails } = useSelector(
    ({ AuthReducer }) => AuthReducer,
  );
  const doesIncludeFeeInOffer = organization.buyerConfig?.doesIncludeFeeInOffer;
  const onShowSizeChange = (changedPage, changedCurrentPageSize) => {
    if (changedPage - 1 !== currentPage) {
      dispatch(setCurrentPage({ page: changedPage - 1 }));
    }
    if (pageSize !== changedCurrentPageSize) {
      dispatch(setPageSize({ pageSize: changedCurrentPageSize }));
    }
    scrollToTheButtonsContainer();
  };
  const pagination = {
    position: ['bottomRight'],
    onChange: onShowSizeChange,
    total,
    pageSize,
    current: currentPage + 1,
    showTotal: (totalItems, range) =>
      `${range[0]}-${range[1]} of ${totalItems} items`,
  };

  useEffect(() => {
    if (mounted) {
      dispatch(
        getOffers({
          page: currentPage,
          pageSize,
          appliedFilters,
        }),
      );
    } else {
      setMounted(true);
    }
  }, [currentPage, pageSize, appliedFilters, mounted]);

  const columns = getColumns(
    dispatch,
    doesIncludeFeeInOffer,
    userDetails.buyersAppDefaultFilters,
  );

  return (
    <div className="offers-table-container">
      <Table
        rowKey="_id"
        bordered
        columns={columns}
        dataSource={offers}
        loading={isFetchingOffers}
        pagination={pagination}
        scroll={tableScroll}
        locale={{
          emptyText: 'No deals match the current filters',
        }}
      />
    </div>
  );
};
